import { render, staticRenderFns } from "./KpiSettings.vue?vue&type=template&id=3f687548&scoped=true&"
import script from "./KpiSettings.vue?vue&type=script&lang=js&"
export * from "./KpiSettings.vue?vue&type=script&lang=js&"
import style0 from "./KpiSettings.vue?vue&type=style&index=0&id=3f687548&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f687548",
  null
  
)

export default component.exports